import verses from "./scriptureVerses.json";

export const SCRIPTURE_VERSION = "RSV-CE";
export const SCRIPTURE_COPYRIGHT = "The Revised Standard Version of the Bible: Catholic Edition, copyright © 1965, 1966 the Division of Christian Education of the National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved.";
export const SCRIPTURE_PERMISSIONS_URL = "https://www.friendshippress.org/pages/nrsvue-quick-faq";
export const CANADIAN_LECTIONARY_URL = "https://www.cccb.ca/media-release/revised-lectionary-approved-for-canada/";
export const scriptureLink = (ref) => `https://www.biblegateway.com/passage/?search=${encodeURIComponent(ref.replace(/[–—]/g, "-"))}&version=RSVCE`;
export const scriptureText = (ref) => {
  const row = verses[ref.replace(/[–—]/g, "-").trim()];
  if (!row) throw new Error(`Missing verified RSV-CE quotation: ${ref}`);
  return row.text;
};
export const scriptureQuote = (ref) => ({ ref: `${ref} · ${SCRIPTURE_VERSION}`, text: scriptureText(ref), url: scriptureLink(ref), edition: SCRIPTURE_VERSION });
export const scripturePrintNotice = (data) => {
  const text = JSON.stringify(data);
  return /RSV-CE|version=RSVCE/.test(text) && !text.includes(SCRIPTURE_COPYRIGHT) ? SCRIPTURE_COPYRIGHT : "";
};